// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__1YqMk","content":"Table_content__3GAuL"};